<kendo-grid [data]="data" [scrollable]="'none'" [hideHeader]="hideHeader">
    <kendo-grid-column *ngFor="let def of columns"
                       [field]="def.field"
                       [title]="def.title"
                       [format]="def.format"
                       [style]="{ width: def.width ? def.width + 'px' : 'auto', 'text-align': def.textAlign??''}"
    >
    </kendo-grid-column>
</kendo-grid>